import React from 'react'
import PropTypes from 'prop-types'
import { kebabCase } from 'lodash'
import Helmet from 'react-helmet'
import { graphql, Link } from 'gatsby'
import Layout from '../components/Layout'
import Content, { HTMLContent } from '../components/Content'
import PlaceholderEgg from "../img/placeholder-egg.svg"

export const RecipeTemplate = ({
  content,
  contentComponent,
  description,
  tags,
  title,
  helmet,
  ingredients,
  method,
  featuredimage
}) => {
  const RecipeContent = contentComponent || Content

  return (
    <>
      <div className="header-clear">
        {helmet || ''}
      </div>
      <div className="recipe">
        <div className="recipe__left">
          {featuredimage ?
            <>
              <picture className="recipe__left-outer">
                <source srcSet={featuredimage.childImageSharp.fluid.srcSetWebp} type="image/webp"></source>
                <img className="recipe__left-inner" src={featuredimage.childImageSharp.fluid.src} alt="" />
              </picture>
            </>
          :
            <img className="recipe__left-inner" src={PlaceholderEgg} alt="" />
          }
        </div>
        <div className="recipe__right">
          <div className="recipe__right-inner article-width">
           <h1>{title}</h1>
           {tags && tags.length ? (
              <>
                <ul className="recipe-tags">
                  {tags.map(tag => (
                    <li key={tag + `tag`}>
                      <Link to={`/tags/${kebabCase(tag)}/`}>{tag}</Link>
                    </li>
                  ))}
                </ul>
              </>
            ) : null}
            <p className="lead-paragraph">{description}</p>
            <RecipeContent content={content} />
            {ingredients && ingredients.length && (
              <>
                <h2>Ingredients</h2>
                <ul>
                  {ingredients.map((ingredient, i) => (
                    <li key={i}>
                      {ingredient.ingredient}
                    </li>
                  ))}
                </ul>
              </>
            )}
            {method && method.length && (
              <>
                <h2>Method</h2>
                <ol>
                  {method.map((instruction, i) => (
                    <li key={i}>
                      {instruction.instruction}
                    </li>
                  ))}
                </ol>
              </>
            )}
          </div>
        </div>
    </div>
  </>
  )
}

RecipeTemplate.propTypes = {
  content: PropTypes.node.isRequired,
  contentComponent: PropTypes.func,
  description: PropTypes.string,
  title: PropTypes.string,
  helmet: PropTypes.object,
  ingredients: PropTypes.array,
  method: PropTypes.array,
  featuredimage: PropTypes.object,
}

const RecipePost = ({ data }) => {
  const { markdownRemark: post } = data
  return (
    <Layout>
      <RecipeTemplate
        content={post.html}
        contentComponent={HTMLContent}
        description={post.frontmatter.description}
        ingredients={post.frontmatter.ingredients}
        method={post.frontmatter.method}
        featuredimage={post.frontmatter.featuredimage}
        helmet={
          <Helmet titleTemplate="%s | Recipes">
            <title>{`${post.frontmatter.title}`}</title>
            <meta
              name="description"
              content={`${post.frontmatter.description}`}
            />
          </Helmet>
        }
        tags={post.frontmatter.tags}
        title={post.frontmatter.title}
      />
    </Layout>
  )
}

RecipePost.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
}

export default RecipePost

export const pageQuery = graphql`
  query RecipePostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        description
        tags
        featuredimage {
          childImageSharp {
            fluid(webpQuality: 100) {
              srcSet
              srcSetWebp
            }
          }
        }
        ingredients {
          ingredient
        }
        method {
          instruction
        }
      }
    }
  }
`
